<template>
  <div>
   
    <button @click="back()">
        返回
    </button>
  </div>
</template>

<script>
export default {
    created(){
        console.log(this.$route)
    },
    methods:{
        back(){
            console.log(this.$router.replace({
                name:"home"
            }))
        }
    }
}
</script>

<style>

</style>